import { useEffect, useState } from "react";
import { Nav, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getGeneralParams } from "../../../features/admin/generalParams/api/generalParamsAPI";
import { ClientGeneralParams } from "../../../features/admin/generalParams/types";
import { setGeneralParamsForm } from "../../../redux/clientParamsSlice";
import MessagesSectionForm from "./tab/MessagesSectionForm";
import AlertMessage from "../../../components/AlertMessage";

interface ClientPreferencesFormProps {
    messageName?: string;
    messageKey?: number;
}

export default function ClientPreferencesForm({ messageName, messageKey }: ClientPreferencesFormProps) {
    const { t } = useTranslation(['clientParams', 'common']);
    const dispatch = useDispatch();
    
    const [tab, setTab] = useState("message");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        getGeneralParams()
            .then(data => dispatch(setGeneralParamsForm(data)))
            .finally(() => setIsLoading(false))
    }, [dispatch, t])

    const updateField = (field: keyof ClientGeneralParams, value: any) => {
        dispatch(setGeneralParamsForm({ [field]: value }));
    };
    
    return (
        <>
            {messageName && (
                <AlertMessage
                    key={messageKey}
                    message={messageName}
                    type="success"
                    displayTime={3000}
                />
            )}
            {isLoading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <Nav variant="tabs" activeKey={tab}>
                <Nav.Item>
                    <Nav.Link
                        eventKey="message"
                        onClick={() => setTab("message")}
                        className={`survey-tab-link ${tab === "message" ? "active-tab" : ""}`}
                    >
                        {t("clientParams:preferences.tabMessageTitle")}
                    </Nav.Link>
                </Nav.Item>
            </Nav>

            <div className="mt-3">
                {tab === "message" && <MessagesSectionForm updateField={updateField}/>}
            </div>
        </>
    );
}



